import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">焦点专题</h2>
          <p className="text-foreground-500 text-sm mt-2">深度调查与重磅策划，看懂网红圈的底层逻辑</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer group">
              <div className="relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-[16/8] object-cover object-top"
                  width="900"
                  height="420"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs rounded whitespace-nowrap font-medium">{item.tag}</span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="text-xs text-background-50/80 mb-1 block">{item.subtitle}</span>
                  <h3 className="text-lg font-heading text-background-50 leading-snug">{item.title}</h3>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-sm text-primary-500 group-hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  查看专题 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}